/* eslint-disable react/button-has-type */
import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import { withClickTracking } from 'components/core/library/tracking-utils';

/**
 * **TODO:** Link button should be updated to call Segment's trackLink function
 * to avoid navigating away from the page before the click is tracked.
 */
// TODO: Refactor withClickTracking/destructure props without HOC
const enhance = withClickTracking;

export function CoreButton({
	href, children, disabled, handleClick, className, target, type, onMouseEnter, onMouseLeave, rel, getRef, ariaLabel, ...rest
}) {
	if (href) {
		return (
			<a
				href={href}
				onClick={handleClick}
				className={classnames('ph-button', className)}
				onMouseEnter={onMouseEnter}
				onMouseLeave={onMouseLeave}
				target={target}
				rel={rel}
				ref={getRef}
				aria-label={ariaLabel}
				{...rest}
			>
				{children}
			</a>
		);
	}
	return (
		<button
			onClick={handleClick}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
			disabled={disabled}
			className={classnames('ph-button', className)}
			type={type}
			ref={getRef}
			aria-label={ariaLabel}
			{...rest}
		>
			{children}
		</button>
	);
}

CoreButton.propTypes = {
	href: PropTypes.string,
	children: PropTypes.node,
	handleClick: PropTypes.func,
	onMouseEnter: PropTypes.func,
	onMouseLeave: PropTypes.func,
	className: PropTypes.string,
	disabled: PropTypes.bool,
	target: PropTypes.string,
	type: PropTypes.string,
	rel: PropTypes.string,
	getRef: PropTypes.func,
};

CoreButton.defaultProps = {
	type: 'button'
};

export default enhance(CoreButton);
